import { Link, LinkProps } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import styles from './CustomLink.styles';

interface CustomLinkComponentProps extends LinkProps {
  to: string;
}

const CustomLinkComponent = function ({ to, ...props }: CustomLinkComponentProps): JSX.Element {
  return (
    <Link sx={styles} component={RouterLink} to={to} {...props}>
      {props.children}
    </Link>
  );
};

export default CustomLinkComponent;
